/*
---------------------------------
Module - events-search-form-suggestions
---------------------------------
*/

(function () {
    
    const eventsSearchForm = (function () {
        
        let $searchForms;

        function setupFBCompletion() {
            // Setup the Funnelback DXP completion for the search forms
            $searchForms.fbcompletion({
                'enabled'    : 'enabled',
                'collection' : 'tcc~sp-whats-on-townsville',
                'program'    : 'https://tcc-search.funnelback.squiz.cloud/s/suggest.json',
                'format'     : 'extended',
                'alpha'      : '0.5',
                'show'       : '3',
                'sort'       : '0',
                'length'     : '3',
                'delay'      : '50',
                'logging'    : 'disabled',
            });

        }

        function init() {

            $searchForms = $(".fb-autocomplete");

            if ($searchForms.length) {

                setupFBCompletion();
                
            }

        }

        return {
            init: init
        };

    })();

    document.addEventListener("DOMContentLoaded", function () {
        eventsSearchForm.init();
    });

})();
